// extracted by mini-css-extract-plugin
export default {"wrap":"Oo-z","fullWidth":"Po-z","items":"Qo-z","featureCss":"Ro-z","disabled":"So-z","imgCss":"To-z"};